import request from '@/utils/request'

export function getSysDicts(data) {
  return request.post('/sys-dictionaries/list', data)
}

export function getCurrentDate(data) {
  return request.post('/closing-date/curr-date', data)
}



// WEBPACK FOOTER //
// ./src/api/commons.js